/*
注意！注意！1、请求路径必须与后端的RequestMapping一致；2、参数命名必须一致

包含n个接口请求函数的模块
函数的返回值: promise对象
 */
// const BASE_URL = 'https://localhost'
// 在config/index.js proxyTable处配置了跨域
import ajax from './ajax'
// const BASE_URL = '/api'

// 测试使用，生产环境要改为空字符串，需同步修改main.js
// const BASE_URL = '/test'
const BASE_URL = '/local'


// export const reqGetAvailableMerchants = (cityCode, sourceLatitude, sourceLongitude, lastQueryIndex) => ajax(`${BASE_URL}/getAvailableMerchants`, {cityCode, sourceLatitude, sourceLongitude, lastQueryIndex})
//
// export const reqGetRecommendAvailableMerchants = (cityCode, sourceLatitude, sourceLongitude, currentMerchantId) => ajax(`${BASE_URL}/getRecommendAvailableMerchants`, {cityCode, sourceLatitude, sourceLongitude, currentMerchantId})
//
// export const reqGetAvailableMerchantsByMerchantName = (cityCode, merchantName, sourceLatitude, sourceLongitude, lastQueryIndex) => ajax(`${BASE_URL}/getAvailableMerchantsByMerchantName`, {cityCode, merchantName, sourceLatitude, sourceLongitude, lastQueryIndex})
//
// export const reqGetMerchantBaseInfo = (merchantId) => ajax(`${BASE_URL}/getMerchantBaseInfo`, {merchantId})
//
// export const reqGetStorefrontAndRecreations = (merchantId) => ajax(`${BASE_URL}/getStorefrontAndRecreations`, {merchantId})
//
// export const reqGetOrders = (phone, lastQueryIndex) => ajax(`${BASE_URL}/getOrders`, {phone, lastQueryIndex})
//
// export const reqGetSubmitOrderQRCode = (merchantId, recreationId, phone) => ajax(`${BASE_URL}/getSubmitOrderQRCode`, {merchantId, recreationId, phone}, 'POST')
//
// export const reqGetRecreation = (id, merchantId) => ajax(`${BASE_URL}/getRecreation`, {id, merchantId})
//
// export const reqCheckOrder = (phone, merchantId, dateTime) => ajax(`${BASE_URL}/checkOrder`, {phone, merchantId, dateTime})
//
// export const reqSaveWebOrder = (merchantId, recreationId, phone) => ajax(`${BASE_URL}/saveWebOrder`, {merchantId, recreationId, phone}, 'POST')





/**
 * HelloController
 * 测试请求
 * @param name 手机号码
 * @param age 短信验证码
 */
export const reqHello = (name, age) => ajax(BASE_URL + '/hello2', {name, age})


/**
 * SMSController
 * 请求发送短信验证码，用于注册 后端是/registerSendCode，不是sendCode
 * @param phone 手机号码
 */
export const reqRegisterSendCode = (phone) => ajax(BASE_URL + '/registerSendCode', {phone})

/**
 * SMSController
 * 请求发送短信验证码，用于注册 后端是/resetPasswordSendCode，不是sendCode
 * @param phone 手机号码
 */
export const reqResetPasswordSendCode = (phone) => ajax(BASE_URL + '/resetPasswordSendCode', {phone})

/**
 * SMSController
 * 请求发送短信验证码 后端是/sendCode
 * @param phone 手机号码
 */
export const reqSendCode = (phone) => ajax(BASE_URL + '/sendCode', {phone})

/**
 * SMSController
 * 请求检查注册验证码是否正确
 * @param phone 手机号码
 * @param code 短信验证码
 */
export const reqCheckCode = (phone, code) => ajax(BASE_URL + '/checkCode', {phone, code})

/**
 * LoginController
 * 请求登录系统
 * @param account 登录账号，可以是手机或用户名
 * @param password 密码
 */
export const reqLogin = (account, password, userType) => ajax(BASE_URL + '/login', {account, password, userType}, 'POST')

/**
 * AdminController
 * 请求登录系统
 * @param account 登录账号，可以是手机或用户名
 * @param password 密码
 */
export const reqAdminLogin = (account, password, userType) => ajax(BASE_URL + '/adminLogin', {account, password, userType}, 'POST')

/**
 * AdminController
 * 请求刷新课程缓存
 */
export const reqReCache = () => ajax(BASE_URL + '/reCache', {}, 'POST')

/**
 * AdminController
 * 请求刷新白名单价格
 */
export const reqReloadWhiteList = () => ajax(BASE_URL + '/reloadWhiteList', {}, 'POST')


/**
 * SystemLogoutFilter
 * 请求退出系统
 */
export const reqLogout = () => ajax(BASE_URL + '/logout', {}, 'POST')

/**
 * LoginController
 * 请求登录系统
 * @param phone 手机号码
 * @param code 短信验证码
 * @param loginType 2-消费者登录 1-商家登录
 */
export const reqCheckCodeLogin = (phone, code, loginType) => ajax(BASE_URL + '/checkCodeLogin', {phone, code, loginType}, 'POST')

/**
 * LoginController
 * 请求重置密码
 * @param loginPhone 登录手机号码
 * @param code 验证码
 * @param email 注册邮箱
 */
export const reqResetPassword = (loginPhone, code, email) => ajax(BASE_URL + '/resetPassword', {loginPhone, code, email}, 'POST')

/**
 * RegisterController
 * 请求注册
 * @param email 邮箱
 * @param loginPhone 手机号码
 * @param password 密码
 */
export const reqRegister = (email, loginPhone, password) => ajax(BASE_URL + '/register', {email, loginPhone, password}, 'POST')

/**
 * CourseController
 * 请求获取所有课程列表
 */
export const reqFindAllCourse = () => ajax(BASE_URL + '/findAllCourse', {})

export const reqFindAllCourse4Admin = () => ajax(BASE_URL + '/findAllCourse4Admin', {})

export const reqUpdateCourse = (formdata, config) => ajax(`${BASE_URL}/updateCourse`, formdata, 'POST', config)


/**
 * CourseController
 * 请求获取指定课程的视频列表
 * @param no 课程编号
 */
export const reqFindCourseVideos = (no) => ajax(BASE_URL + '/findCourseVideos', {no})

/**
 * CourseController
 * 请求获取指定课程的视频
 * @param no 课程编号
 * @param videoNo 视频编号
 */
export const reqGetCourseVideo = (no, videoNo) => ajax(BASE_URL + '/getCourseVideo', {no, videoNo})

/**
 * CourseController
 * 请求检查是否购买了课程
 * @param no 课程编号
 */
export const reqCheckBuyCourse = (no) => ajax(BASE_URL + '/checkBuyCourse', {no})

/**
 * CourseController
 * 请求获取指定课程的资料
 * @param no 课程编号
 * @param id 资料id
 */
export const reqGetCourseMaterial = (no, id) => ajax(BASE_URL + '/getCourseMaterial', {no, id})

/**
 * CourseController
 * 请求新增课程笔记打开记录
 * @param no 课程编号
 * @param id 资料id
 */
export const reqAddMaterialClickHistory = (no, id) => ajax(BASE_URL + '/addMaterialClickHistory', {no, id})

/**
 * AdminController
 * 请求新增课程笔记打开记录
 * @param no 课程编号
 * @param id 资料id
 */
export const reqFindAllVideoClickHistory = (phone, name='', startDay='', endDay='', currentPage) => ajax(BASE_URL + '/findAllVideoClickHistory', {phone, name, startDay, endDay, currentPage})

export const reqFindAllVideoPlayHistory = (phone, currentPage) => ajax(BASE_URL + '/findAllVideoPlayHistory', {phone, currentPage})

export const reqFindAllMaterialClickHistory = (phone, currentPage) => ajax(BASE_URL + '/findAllMaterialClickHistory', {phone, currentPage})

export const reqFindAllOrders = (phone, currentPage) => ajax(BASE_URL + '/findAllOrders', {phone, currentPage})

export const reqFindAllCustomers = (phone, currentPage) => ajax(BASE_URL + '/findAllCustomers', {phone, currentPage})

/**
 * CourseController
 * 请求更新课程播放记录
 * @param no 课程编号
 * @param videoNo 视频编号
 * @param duration 播放时长
 */
export const reqUpdateCoursePlayInfo = (no, videoNo, duration) => ajax(BASE_URL + '/updateCoursePlayInfo', {no, videoNo, duration}, 'POST')

/**
 * CourseController
 * 请求获取用户的课程播放记录
 */
export const reqFindCoursePlayInfo = () => ajax(BASE_URL + '/findCoursePlayInfo', {})

/**
 * CourseController
 * 请求获取所有课程播放信息
 * @param phone 客户手机号码
 * @param currentPage 页号
 */
export const reqFindAllCoursePlayInfos = (phone, name, currentPage) => ajax(BASE_URL + '/findAllCoursePlayInfos', {phone, name, currentPage})


/**
 * OrderController
 * 请求获取指定客户的订单列表
 * @param loginPhone 客户手机号码
 */
export const reqFindCustomerOrders = () => ajax(BASE_URL + '/findCustomerOrders', {})


/**
 * LoginController
 * 请求更新密码
 * @param originPassword 原密码
 * @param password 新密码
 */
export const reqUpdatePassword = (originPassword, password) => ajax(BASE_URL + '/updatePassword', {originPassword, password}, 'POST')

/**
 * InvoiceController
 * 请求获取当前用户的发票信息
 * @param formdata
 * @param config
 */
export const reqGetInvoiceInfo = () => ajax(`${BASE_URL}/getInvoiceInfo`, {})

/**
 * InvoiceController
 * 请求开发票
 * @param formdata
 * @param config
 */
export const reqInvoice = (formdata, config) => ajax(`${BASE_URL}/invoice`, formdata, 'POST', config)

/**
 * InvoiceController
 * 请求获取所有发票
 * @param phone 客户手机号码
 * @param currentPage 页号
 */
export const reqFindAllInvoices = (phone, currentPage) => ajax(BASE_URL + '/findAllInvoices', {phone, currentPage})

/**
 * InvoiceController
 * 请求更新发票状态
 * @param phone 客户手机号码
 * @param currentPage 页号
 */
export const reqUpdateInvoice = (id, orderId) => ajax(BASE_URL + '/updateInvoice', {id, orderId}, 'POST')


/**
 * OrderController
 * 请求保存订单
 * @param no 课程编号
 * @param name 课程名称
 */
export const reqSaveOrder = (no, name) => ajax(`${BASE_URL}/saveOrder`, {no, name}, 'POST')

/**
 * OrderController
 * 请求检查订单支付状态
 * @param orderNo 订单编号
 */
export const reqCheckPayStatus = (orderNo) => ajax(`${BASE_URL}/checkPayStatus`, {orderNo}, 'POST')



// WEBPACK FOOTER //
// ./src/api/index.js